import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import InferenceClassification from 'owa-service/lib/contract/InferenceClassification';
import ItemChange from 'owa-service/lib/contract/ItemChange';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import PropertyUpdate from 'owa-service/lib/contract/PropertyUpdate';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getOutboundCharset from 'owa-session-store/lib/selectors/getOutboundCharset';

function createRequestBody(
    itemIdsToUpdate: string[],
    inferenceClassification: InferenceClassification
) {
    const itemChanges: ItemChange[] = [];
    for (const messageItemId of itemIdsToUpdate) {
        const update: PropertyUpdate = createSetItemField(
            'InferenceClassification',
            inferenceClassification
        );
        const singleItemChange = itemChange({
            Updates: [update],
            ItemId: itemId({
                Id: messageItemId,
            }),
        });

        itemChanges.push(singleItemChange);
    }

    // MessageDisposition attribue is needed for UpdateItem call
    return updateItemRequest({
        ConflictResolution: 'AlwaysOverwrite',
        ItemChanges: itemChanges,
        MessageDisposition: 'SaveOnly',
        ...getOutboundCharset(),
    });
}

export default function setItemsInferenceClassificationService(
    itemIdsToUpdate: string[],
    inferenceClassification: InferenceClassification
): Promise<UpdateItemResponseMessage> {
    const requestBody = createRequestBody(itemIdsToUpdate, inferenceClassification);

    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    const jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';

    return updateItemOperation({
        Header: jsonRequestHeader,
        Body: requestBody,
    })
        .then(response => {
            return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
